import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../theme';

const { spacing, breakpoints } = redesignTheme;

export const useCompassStyles = makeStyles(() => ({
  page: {
    [`@media (min-width: ${breakpoints.desktop}px)`]: {
      paddingLeft: 80,
      paddingRight: 80,
    },
  },
  sectionsStack: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.md,
  },
}));
